var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.162,
    height: 66.02,
    viewBox: "0 0 85.162 66.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(-265.911 -227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1138_",
    transform: "translate(283 225.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2272_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2279_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2282_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2294_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2352_",
    d: "M41.1,19H12.6a1,1,0,0,1,0-2H41.1a1,1,0,0,1,0,2Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2351_",
    d: "M39.2,19H14.6a.974.974,0,0,1-1-.8,14.279,14.279,0,0,1-.3-2.9,13.6,13.6,0,0,1,27.2.1,15.04,15.04,0,0,1-.3,2.9A1.2,1.2,0,0,1,39.2,19ZM15.4,17H38.3a9.7,9.7,0,0,0,.1-1.7A11.333,11.333,0,0,0,26.9,4,11.5,11.5,0,0,0,15.3,15.4a9.151,9.151,0,0,0,.1,1.6Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2350_",
    d: "M26.9,34.2c-6.5,0-11.7-6.5-11.7-14.5a7.569,7.569,0,0,1,.1-1.5v-.4a1.172,1.172,0,0,1,1.1-.9,1.172,1.172,0,0,1,.9,1.1v.3c0,.4-.1.9-.1,1.3,0,6.9,4.4,12.5,9.7,12.5,5.4,0,9.7-5.6,9.7-12.5a5.283,5.283,0,0,0-.1-1.3V18a.993.993,0,0,1,.9-1.1.945.945,0,0,1,1.1.9v.3c0,.5.1,1,.1,1.5,0,8.1-5.3,14.6-11.7,14.6Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2347_",
    d: "M36.7,39.4a1.08,1.08,0,0,1-.7-.3l-3.4-3.2a1.08,1.08,0,0,1-.3-.7V30.6a1,1,0,1,1,2,0v4.3l3,2.9a.967.967,0,0,1,0,1.4,1.072,1.072,0,0,1-.6.2Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2321_",
    d: "M33.1,58.7H3a.945.945,0,0,1-1-1V47.5c.7-2.5,3.8-4.9,9-7.2a50,50,0,0,1,6.1-2.2l2.8-2.8V31a1,1,0,0,1,2,0v4.7a.908.908,0,0,1-.3.7l-3.2,3.2a.55.55,0,0,1-.5.3,44.783,44.783,0,0,0-6.1,2.2c-4.5,1.9-7.3,4-7.9,5.8v8.8H33a.945.945,0,0,1,1,1A.827.827,0,0,1,33.1,58.7Z",
    fill: "#444"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2285_",
    d: "M27.2,14.7a4.4,4.4,0,1,1,4.4-4.4,4.507,4.507,0,0,1-4.4,4.4Zm0-6.8a2.4,2.4,0,1,0,2.4,2.4,2.5,2.5,0,0,0-2.4-2.4Z",
    fill: "#444"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2280_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2281_",
    d: "M17.8,58.7H11.5a.945.945,0,0,1-1-1V41.2a1,1,0,0,1,2,0V56.7h4.3V39a1,1,0,0,1,2,0V57.7A1,1,0,0,1,17.8,58.7Z",
    fill: "#444"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2273_",
    d: "M26.9,42.6a.908.908,0,0,1-.7-.3l-5.8-5.8a.99.99,0,0,1,1.4-1.4l5.1,5.1,5.7-5.7A.99.99,0,0,1,34,35.9l-6.4,6.4A1.08,1.08,0,0,1,26.9,42.6Z",
    fill: "#444"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2088_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2271_",
    d: "M61.2,68a5.222,5.222,0,0,1-2.1-.4L42.3,61.7a1.024,1.024,0,0,1-.6-.5,1.1,1.1,0,0,1,0-.8l3.9-11.2a1.04,1.04,0,0,1,1.3-.6l16.8,5.9a6.506,6.506,0,0,1,4,8.3l-.3.8A6.644,6.644,0,0,1,61.2,68ZM43.8,60.2l15.9,5.5a4.467,4.467,0,0,0,5.7-2.8l.3-.8a4.467,4.467,0,0,0-2.8-5.7L47,50.9l-3.2,9.3Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2096_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2270_",
    d: "M43.2,60a.367.367,0,0,1-.3-.1l-4.3-1.5a1.04,1.04,0,0,1-.6-1.3l2.7-7.6a1.024,1.024,0,0,1,.5-.6,1.1,1.1,0,0,1,.8,0l4.3,1.5a1.04,1.04,0,0,1,.6,1.3l-2.7,7.6a1.024,1.024,0,0,1-.5.6A1.087,1.087,0,0,1,43.2,60Zm-3.1-3.1,2.4.8,2-5.7-2.4-.8Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2269_",
    d: "M39.5,56.6a.367.367,0,0,1-.3-.1L27.9,52.6l-1.7.3a1.008,1.008,0,0,1-.9-.3,1.163,1.163,0,0,1-.2-1L27,46.1a1.143,1.143,0,0,1,.8-.7,1.008,1.008,0,0,1,.9.3L29.8,47l11.3,4a1.04,1.04,0,0,1,.6,1.3l-1.3,3.6a1.024,1.024,0,0,1-.5.6c-.1,0-.2.1-.4.1ZM28,50.5a.367.367,0,0,1,.3.1l10.6,3.7.6-1.7L28.9,48.9a1.38,1.38,0,0,1-.4-.3l-.2-.2-.8,2.2h.2C27.9,50.5,27.9,50.5,28,50.5Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2102_",
    d: "M26,52.9a.749.749,0,0,1-.5-.1l-5.4-3.2a.926.926,0,0,1-.4-1.2l1.1-3.1a1.23,1.23,0,0,1,1.1-.7l6.2.8a.752.752,0,0,1,.7.5.972.972,0,0,1,.1.9L27,52.2a.9.9,0,0,1-.6.6c-.1.1-.2.1-.4.1Zm-4.1-4.7,3.6,2.2,1.1-3.2-4.2-.6-.5,1.6Z",
    fill: "#444"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2095_",
    d: "M59,67.6a.367.367,0,0,1-.3-.1,1.04,1.04,0,0,1-.6-1.3L61.9,55a1.012,1.012,0,0,1,1.9.7L59.9,66.9a.961.961,0,0,1-.9.7Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2094_",
    d: "M60.9,61.9a.367.367,0,0,1-.3-.1L44.2,56.1a1.012,1.012,0,1,1,.7-1.9L61.3,60a1.04,1.04,0,0,1,.6,1.3,1.1,1.1,0,0,1-1,.6Z",
    fill: "#444"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1144_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2083_",
    d: "M47.3,32.7a.6.6,0,0,1-.4-.1.917.917,0,0,1-.5-1.3l6.9-16.7a.985.985,0,1,1,1.8.8L48.2,32.1a.961.961,0,0,1-.9.6Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2062_",
    d: "M53.1,35.1a.6.6,0,0,1-.4-.1.917.917,0,0,1-.5-1.3L59,17.1a.985.985,0,0,1,1.8.8L54,34.5A.961.961,0,0,1,53.1,35.1Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2044_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2059_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2061_",
    d: "M59.7,18.5a7.535,7.535,0,0,1-3.3-.7,9.038,9.038,0,0,1-3-2.1A8.273,8.273,0,0,1,51.7,7a8.022,8.022,0,0,1,6.8-5,.945.945,0,0,1,1.1.9A.993.993,0,0,1,58.7,4a6.025,6.025,0,0,0-5.1,3.8,6.231,6.231,0,0,0,1.3,6.6A6.342,6.342,0,0,0,57.2,16a6.355,6.355,0,0,0,8.3-3.3,6.379,6.379,0,0,0-.8-6.1,1.075,1.075,0,0,1,.2-1.4,1.075,1.075,0,0,1,1.4.2,8.036,8.036,0,0,1,1.1,8,8.26,8.26,0,0,1-7.4,5,.367.367,0,0,1-.3.1Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2060_",
    d: "M58.9,13.1a.961.961,0,0,1-.9-.6L55.8,8a1.1,1.1,0,0,1,0-.8l1.9-4.6A.917.917,0,0,1,59,2.1a.917.917,0,0,1,.5,1.3L57.8,7.6l1.6,3.3,3.4-1.2,1.7-4a.985.985,0,0,1,1.8.8L64.5,11a.9.9,0,0,1-.6.6L59.3,13c-.1,0-.3.1-.4.1Z",
    fill: "#444"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2045_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2047_",
    d: "M48.9,47.1a1.063,1.063,0,0,1-1-.9.937.937,0,0,1,.8-1.1,6.065,6.065,0,0,0,3.6-10.3A6.342,6.342,0,0,0,50,33.2a6.461,6.461,0,0,0-2.7-.5,6.284,6.284,0,0,0-5.6,3.8,6.064,6.064,0,0,0,1,6.3,1.063,1.063,0,0,1-.1,1.4.966.966,0,0,1-1.4-.1,8.378,8.378,0,0,1-1.3-8.3,8.26,8.26,0,0,1,7.4-5,9.223,9.223,0,0,1,3.6.7,12.086,12.086,0,0,1,3,2,8.273,8.273,0,0,1,1.7,8.7,7.963,7.963,0,0,1-6.4,4.9h-.3Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2046_",
    d: "M48.9,47.1a.6.6,0,0,1-.4-.1.917.917,0,0,1-.5-1.3l1.7-4L48,38.4l-3.4,1.2-1.7,4.2a.985.985,0,1,1-1.8-.8L43,38.4a.9.9,0,0,1,.6-.6l4.7-1.6a.967.967,0,0,1,1.2.5l2.2,4.5a1.1,1.1,0,0,1,0,.8l-1.8,4.5a1.1,1.1,0,0,1-1,.6Z",
    fill: "#444"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(258.729 235.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M28.077,33.822a.678.678,0,0,1-.479-1.157l7.081-7.081-1.914-1.914a.678.678,0,0,1,.959-.959L36.117,25.1a.678.678,0,0,1,0,.959l-7.56,7.56a.676.676,0,0,1-.479.2Z",
    transform: "translate(-6.509 -4.63)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M24.537,31.427a.678.678,0,0,1-.479-1.158L31.6,22.735a.677.677,0,0,1,1.183.447v.007a.679.679,0,0,1-.2.48l-7.567,7.561a.677.677,0,0,1-.479.2Z",
    transform: "translate(-5.369 -4.629)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M10.911,40.5a3.728,3.728,0,0,1-2.637-6.365l8.39-8.39a.677.677,0,0,1,.444-.2l3.644-.192a.682.682,0,0,1,.515.2l.863.863a.677.677,0,0,1,.2.515l-.192,3.644a.677.677,0,0,1-.2.444l-8.39,8.39A3.717,3.717,0,0,1,10.911,40.5Zm6.528-13.612L9.233,35.095a2.373,2.373,0,0,0,1.678,4.051h0a2.357,2.357,0,0,0,1.678-.695L20.8,30.245l.162-3.083-.436-.436Zm17.446.493a.677.677,0,0,1-.479-.2l-3.123-3.121a.679.679,0,0,1-.192-.573,1,1,0,0,0-1.142-1.142.672.672,0,0,1-.573-.192l-4.139-4.137a.679.679,0,0,1-.181-.632l.468-2.027a16.789,16.789,0,0,0-7.182-5.282.678.678,0,0,1,.039-1.28,14.543,14.543,0,0,1,6.54-.5,14.319,14.319,0,0,1,4.529,1.51.673.673,0,0,1,.162.12l4.759,4.759a.66.66,0,0,1,.057.057l1.182,1.182a.678.678,0,0,1,.192.572,1,1,0,0,0,1.142,1.142.676.676,0,0,1,.572.192l3.122,3.122a.678.678,0,0,1,0,.959l-5.272,5.272a.676.676,0,0,1-.479.2Zm-2.428-4.063,2.428,2.426L39.2,21.431,36.771,19a2.355,2.355,0,0,1-2.338-2.338l-.988-.988-.012-.012-4.711-4.71a12.913,12.913,0,0,0-8.037-1.309A18.136,18.136,0,0,1,26.8,14.79a.678.678,0,0,1,.12.563l-.456,1.974,3.658,3.655a2.355,2.355,0,0,1,2.339,2.337Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M14.756,52.421a.676.676,0,0,1-.479-.2l-.959-.959a.678.678,0,1,1,.959-.959l.959.959a.678.678,0,0,1-.479,1.157Zm-2.4-2.394a.852.852,0,0,1-.129-.014c-.047-.014-.088-.027-.129-.041s-.081-.041-.115-.061a.67.67,0,0,1-.109-.088.679.679,0,0,1,0-.956.67.67,0,0,1,.109-.088c.034-.02.074-.04.115-.061a.7.7,0,0,1,.129-.034.576.576,0,0,1,.265,0,1.188,1.188,0,0,1,.129.034c.041.021.074.041.115.061a1.153,1.153,0,0,1,.1.088.679.679,0,0,1,0,.956,1.151,1.151,0,0,1-.1.088c-.041.02-.074.04-.115.061s-.088.027-.129.041A.948.948,0,0,1,12.357,50.027Z",
    transform: "translate(-1.448 -13.052)",
    fill: "#444"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateService);
export default __webpack_public_path__ + "static/media/create_service.e8e67525bd6a8e5ef7a88db4efd47e03.svg";
export { ForwardRef as ReactComponent };